import { render, staticRenderFns } from "./AgendaEventCard.vue?vue&type=template&id=4781ddd8&scoped=true"
import script from "./AgendaEventCard.vue?vue&type=script&lang=js"
export * from "./AgendaEventCard.vue?vue&type=script&lang=js"
import style0 from "./AgendaEventCard.vue?vue&type=style&index=0&id=4781ddd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781ddd8",
  null
  
)

export default component.exports